export default "__VITE_ASSET__6d32a21d__"